/**
 * Calculates the relative luminance of a color using the WCAG formula
 * @param hexColor - Color in hex format (e.g., "#1868DB" or "1868DB")
 * @returns Relative luminance value between 0 and 1
 * @see https://www.w3.org/TR/WCAG20/#relativeluminancedef
 */
export const getLuminance = (hexColor: string): number => {
	// remove # if present
	const hex = hexColor.replace('#', '');

	// validate hex format
	if (!/^[0-9A-Fa-f]{6}$/.test(hex)) {
		throw new Error(`Invalid hex color format: ${hexColor}. Expected format: #RRGGBB or RRGGBB`);
	}

	// convert to RGB
	const r = parseInt(hex.substring(0, 2), 16);
	const g = parseInt(hex.substring(2, 4), 16);
	const b = parseInt(hex.substring(4, 6), 16);

	// calculate relative luminance using WCAG formula
	// L = 0.299 * R + 0.587 * G + 0.114 * B
	const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

	return luminance;
};

export const isDarkColor = (hexColor: string): boolean => {
	return getLuminance(hexColor) < 0.5;
};
